module.exports = "@media only screen and (min-width: 821px) {\n  .toggleAcompanhante {\n    margin-top: 36px;\n  }\n}\n\n.pt0 {\n  padding-top: 0;\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/viagens/pontos/ponto-deslocamento-form-list/ponto-deslocamento-form-list.component.css
 ** module id = 943
 ** module chunks = 0
 **/